import { Flex } from 'components/common/styles'
import { StyledButton } from 'components/common/Button/Button.styles'
import {
  PRIMARY_TEXT,
  GRAY4,
  TERTIARY_TEXT,
  PURPLE,
  WHITE,
  GRAY2,
  BLACK_RGB,
  PURPLE_HOVER,
} from 'constants/colors'
import styled from 'styled-components'
import { Popper } from '@material-ui/core'

export const StyledPopper = styled(Popper)`
  .MuiPaper-root {
    padding: 0;
    border: 1px solid ${GRAY2};
    border-radius: 8px;
    box-shadow: 0 2px 20px 0 rgba(${BLACK_RGB}, 0.1);

    .rdrDefinedRangesWrapper {
      padding: 24px 16px;
      width: auto;

      .rdrStaticRange {
        margin-bottom: 18px;

        &.rdrStaticRangeSelected {
          color: ${PRIMARY_TEXT}!important;
          background: ${GRAY4};
          border-radius: 8px;
        }

        .rdrStaticRangeLabel {
          padding: 8px 16px;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    .rdrCalendarWrapper {
      padding: 24px 16px 0;

      .rdrMonthAndYearWrapper {
        padding: 0;
        height: auto;

        .rdrNextPrevButton {
          position: relative;
          margin: 0;
          background: transparent;
          width: 38px;
          height: 38px;

          i {
            display: none;
          }

          &:before {
            position: absolute;
            content: '';
            border: solid ${PRIMARY_TEXT};
            border-width: 0 0 2px 2px;
            border-radius: 2px;
            height: 10px;
            width: 10px;
            left: 50%;
            top: 50%;
          }

          &.rdrPprevButton {
            &:before {
              transform: translate(-50%, -50%) rotateZ(45deg);
            }
          }

          &.rdrNextButton {
            &:before {
              transform: translate(-50%, -50%) rotateZ(-135deg);
            }
          }
        }
      }

      .rdrMonthAndYearPickers {
        font-size: 16px;
        line-height: 22px;
      }

      .rdrMonth {
        font-size: 14px;
        line-height: 20px;
        padding: 10px;
        width: auto;

        .rdrMonthName {
          padding: 10px;
          color: ${TERTIARY_TEXT};
          font-size: 16px;
          line-height: 22px;
        }

        .rdrWeekDay {
          line-height: inherit;
          padding: 10px 9px;
          width: 48px;
        }

        .rdrDayToday .rdrDayNumber span:after {
          background: ${PURPLE};
        }

        .rdrStartEdge,
        .rdrInRange,
        .rdrEndEdge {
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          + .rdrDayNumber span:after {
            background: ${WHITE};
          }
        }

        .rdrStartEdge,
        .rdrEndEdge {
          color: ${PURPLE}!important;
        }

        .rdrInRange {
          color: ${PURPLE_HOVER}!important;
        }

        .rdrDayStartPreview,
        .rdrDayInPreview,
        .rdrDayEndPreview {
          border-color: ${PURPLE};
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          + .rdrDayNumber span:after {
            background: ${PURPLE};
          }
        }

        .rdrDay {
          height: 48px;
          line-height: 48px;
          font-size: 48px;

          .rdrDayNumber {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }

      .rdrInRange ~ .rdrDayNumber span {
        color: ${PRIMARY_TEXT};
      }
    }
  }
`

export const StyledButtonHolder = styled(Flex)`
  padding: 8px 24px 24px;

  ${StyledButton} {
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
`

export const TextFieldWrapper = styled.div`
  .MuiTextField-root input {
    caret-color: transparent;
  }
`
